module.exports = __webpack_public_path__ + "static/media/2023.7.7_fairearth_side_logo_two_color.03cdbe0e.png";